/**
 * @generated SignedSource<<97308a29eabdf9c5e9bdabb6e22b2581>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LoginFromWebappInput = {
  clientMutationId?: string | null;
  email: string;
  password: string;
};
export type useAuthContext_LoginMutation$variables = {
  input: LoginFromWebappInput;
};
export type useAuthContext_LoginMutation$data = {
  readonly Auth: {
    readonly loginFromWebapp: {
      readonly loginResult: {
        readonly firstLogin: boolean;
        readonly isAVGSClient: boolean;
        readonly jwtTokens: {
          readonly accessToken: string;
          readonly refreshToken: string;
        };
        readonly potentialAnalysisId: string | null;
      };
    } | null;
  };
};
export type useAuthContext_LoginMutation = {
  response: useAuthContext_LoginMutation$data;
  variables: useAuthContext_LoginMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthMutations",
    "kind": "LinkedField",
    "name": "Auth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "LoginFromWebappPayload",
        "kind": "LinkedField",
        "name": "loginFromWebapp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LoginFromWebappResult",
            "kind": "LinkedField",
            "name": "loginResult",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JwtLoginInformation",
                "kind": "LinkedField",
                "name": "jwtTokens",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshToken",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstLogin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isAVGSClient",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "potentialAnalysisId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAuthContext_LoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAuthContext_LoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7b54c52f11456699f07365ebd466a112",
    "id": null,
    "metadata": {},
    "name": "useAuthContext_LoginMutation",
    "operationKind": "mutation",
    "text": "mutation useAuthContext_LoginMutation(\n  $input: LoginFromWebappInput!\n) {\n  Auth {\n    loginFromWebapp(input: $input) {\n      loginResult {\n        jwtTokens {\n          accessToken\n          refreshToken\n        }\n        firstLogin\n        isAVGSClient\n        potentialAnalysisId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c84509bfd9dfbabf21295f667901564b";

export default node;
